<template>
    <div class="side-bar-thumbnail">
        <div v-if="hasThumbnail" class="gallery-thumbnail" :class="thumbnailClasses" :style="thumbnailStyles"></div>
        <template v-else>
            <div :style="{backgroundImage: `url('${placeholder}')`}" class="gallery-thumbnail"></div>
        </template>
    </div>
</template>

<script>
import { has } from 'lodash';
import { testImageUrl } from '@/helper/url';

export default {
    name: 'Thumbnail',
    props: {
        item: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String,
            default: ca.config('media.placeholders.thumbnail')
        },
    },
    data() {
        return {
            hasThumbnail: false,
        }
    },
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler(newValue) {
                if (newValue.hasDataUrl || newValue.url) {
                    if (has(newValue, 'config') && has(newValue.config, 'thumbnail')) {
                        this.hasThumbnail = !newValue.config.thumbnail.disabled;
                    }

                    // check thumbnail actually exists
                    if (!newValue.hasDataUrl) {
                        testImageUrl(`${newValue.url}?p=thumb`)
                            .then(response => {
                                this.hasThumbnail = true
                            }).catch(error => {
                                this.hasThumbnail = false;
                            });
                    }
                } else {
                    this.hasThumbnail = false;
                }
            }
        }
    },
    computed: {
        thumbnail() {
            let thumbnail = false;
            thumbnail = this.item.hasDataUrl ? this.item.url : this.item.thumbnail();
            return thumbnail;
        },
        thumbnailClasses() {
            return {
                'is-pending': this.item.thumbnailPending,
            }
        },
        thumbnailStyles() {
            return {
                backgroundImage: `url('${this.thumbnail}')`,
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    .side-bar-thumbnail {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }

    .gallery-thumbnail {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100%;
        width: 100%;
        height: 100%;

         &.is-pending, &.is-processing {

            &:before {
                content: '';
                display: flex;
                align-items: flex-start;
                justify-content: center;
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                z-index: 4;
                background: rgba(white, 0.6);
                font-weight: 600;
                padding-top: 21%; // try and align text to center of image
                color: #28a5d4;
                font-size: 2rem;
                font-style: italic;
                cursor: not-allowed;
            }
        }

         &.is-pending:before, &.is-processing:before {
            content: 'Your upload is processing...';
        }
    }
</style>
